export var FileLoadEvent;
(function (FileLoadEvent) {
    FileLoadEvent["Next"] = "next";
    FileLoadEvent["Chunk"] = "chunk";
    FileLoadEvent["End"] = "end";
    FileLoadEvent["Error"] = "error";
})(FileLoadEvent || (FileLoadEvent = {}));
export var FileSaveEvent;
(function (FileSaveEvent) {
    FileSaveEvent["Saved"] = "saved";
    FileSaveEvent["Cancel"] = "cancel";
    FileSaveEvent["Error"] = "error";
})(FileSaveEvent || (FileSaveEvent = {}));
export var StateErrorType;
(function (StateErrorType) {
    StateErrorType["NotSupported"] = "not-supported";
    StateErrorType["StatError"] = "stat-error";
})(StateErrorType || (StateErrorType = {}));
//# sourceMappingURL=mega-file-service.protocol.js.map